var map = {
	"./07.png": 234,
	"./IMG-20201016-WA0003.jpg": 235,
	"./IMG-20201016-WA0004.jpg": 236,
	"./IMG-20201016-WA0005.jpg": 237,
	"./IMG-20201016-WA0006.jpg": 238,
	"./IMG-20201016-WA0007.jpg": 239,
	"./IMG-20201016-WA0008.jpg": 240,
	"./IMG-20201016-WA0009.jpg": 241,
	"./IMG-20201016-WA0010.jpg": 242,
	"./IMG-20201016-WA0011.jpg": 243,
	"./IMG-20201016-WA0012.jpg": 244,
	"./IMG-20201016-WA0013.jpg": 245,
	"./IMG-20201016-WA0014.jpg": 246,
	"./IMG-20201016-WA0015.jpg": 247,
	"./IMG-20201016-WA0016.jpg": 248,
	"./IMG-20201016-WA0017.jpg": 249,
	"./IMG-20201016-WA0018.jpg": 250,
	"./IMG-20201016-WA0019.jpg": 251,
	"./IMG-20201016-WA0020.jpg": 252,
	"./IMG-20201016-WA0021.jpg": 253,
	"./IMG-20201016-WA0022.jpg": 254,
	"./IMG-20201016-WA0023.jpg": 255,
	"./IMG-20201016-WA0024.jpg": 256,
	"./IMG-20201016-WA0025.jpg": 257,
	"./IMG-20201016-WA0026.jpg": 258,
	"./IMG-20201016-WA0028.jpg": 259,
	"./IMG-20201016-WA0029.jpg": 260,
	"./IMG-20201016-WA0030.jpg": 261,
	"./IMG-20201016-WA0031.jpg": 262,
	"./IMG-20201016-WA0032.jpg": 263,
	"./IMG-20201016-WA0033.jpg": 264,
	"./IMG-20201016-WA0034.jpg": 265,
	"./banner3.png": 94,
	"./book1.jpg": 136,
	"./book2.jpg": 137,
	"./book3.jpg": 138,
	"./book4.jpg": 133,
	"./book4_1.jpg": 134,
	"./book4_2.jpg": 135,
	"./c1.png": 92,
	"./c2.png": 93,
	"./dottedpattern.png": 95,
	"./green.png": 266,
	"./milestone_02.png": 91,
	"./person.png": 89,
	"./person2.png": 90,
	"./person3.png": 88,
	"./rotarylogo.png": 96,
	"./saiKiruba.png": 58,
	"./template-around-kumbakonam.jpg": 267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;